<template>
  <div class="my-0">
    <div class="mx-auto text-center">
      <h1>VIP Program</h1>
      <p class="max-w-md mx-auto">
        [who we help] Implicit is for people committed to growth
        and advancing their place within their career
      </p>
      <p class="max-w-md mx-auto">
        [why that matters to you] You’re an individual that has made
        a career of helping people like that grow.
      </p>
      <p class="max-w-md mx-auto">
        [how we help you] If you join our Implicit VIP program, we will
        help you extend your voice and deliver more value to more people
      </p>
      <p class="max-w-md mx-auto">
        Implicit helps professionals find and learn from the latest
        insights, strategies, techniques, and tactics.
      </p>
      <p class="max-w-md mx-auto">
        We are inviting
        <!-- thought-leaders, influencers, and experts --> those who
        regularly share insights to create a profile
        so that their followers can connect directly and learn through
        their lens on the internet.
        <!-- with the noise filtered out -->
      </p>
    </div>
    <div class="float-left w-1/2 text-center">
      <h2>The Program</h2>
      <p>Concierge Service<br>
        <i><small>
          5 minutes of setup and we manage your account to make sure that the service
          is valuable for you (your feature requests are prioritized)
        </small></i>
      </p>
      <p>All Pro Features<br>
        <i><small>
          public &amp; private feeds, branding, user-engagement tools,
          integrations, team access &amp; more
        </small></i>
      </p>
    </div>
    <div class="float-left w-1/2 text-center">
      <h2>Apply for the program</h2>
      <p class="max-w-md mx-auto">
        We will bring together content from you and those that you respect.
        Your followers will learn through your lens, and you will be able to
        engage directly with them.
      </p>
      <button v-on:click="applyWithTwitter" class="bg-primaryLight text-black text-center p-4 text-xl">
        Apply using Twitter
      </button>
      <p class="mt-4 max-w-md mx-auto">
        Click 'Apply' to agree to provide feedback as well as agree to
        our <a href="/terms">terms of service</a> and
        <a href="/privacy">privacy policy</a>.
      </p>
    </div>
  </div>
</template>

<script>
// import twitterAuth from '@/services/twitterAuth';

export default {
  name: 'VIP',
  data() {
    return {
    };
  },
  methods: {
    async applyWithTwitter() {
      // await twitterAuth.startSignUpWorkflow();
    },
  },
};
</script>
